<template>
    <div class="relative h-full" ref="orderByDropdownModal">
        <button 
        class="inline-flex items-center text-gray-500 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-4 py-2 h-full" 
        type="button"
        @click="showDropdown = true">
            <IconArrowsSort class="w-5 h-5 me-2" stroke={2} />{{ $t("provider.auto.ordenar_por") }}<svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
            </svg>
        </button>
        <!-- Dropdown menu -->
        <div 
        class="z-10 w-60 absolute top-10 left-1  bg-white divide-y divide-gray-100 rounded-md shadow border border-eblack-200" 
        :hidden="!showDropdown">
            <div class="w-full flex flex-col gap-3 px-4 p-2">
                <p class="text-sm">{{ $t("provider.auto.escoger_por") }}</p>

                <div class="flex items-center">
                    <input 
                    id="commission" 
                    type="radio" 
                    value="commission" 
                    name="order_by" 
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                    @change="handleOrderBy($event)">
                    <label 
                    for="commission" 
                    class="ms-2 text-sm font-medium text-gray-900">{{ $t("provider.auto.comision") }}</label>
                </div>
                <div class="flex items-center">
                    <input
                    id="name" 
                    type="radio" 
                    value="name" 
                    name="order_by" 
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                    @change="handleOrderBy($event)">
                    <label for="name" class="ms-2 text-sm font-medium text-gray-900">{{ $t("provider.auto.nombre") }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { IconArrowsSort } from '@tabler/icons-vue';

export default {
    name:'OrderBy',
    props:['applyOrderBy'],
    data(){
        return {
            showDropdown:false
        }
    },
    components:{
        IconArrowsSort
    },
    methods:{
        handleClickOutside(event) {
            if (this.$refs.orderByDropdownModal && !this.$refs.orderByDropdownModal.contains(event.target)) {
                this.showDropdown = false;
            }
        },
        handleOrderBy($event){
            this.applyOrderBy($event.target.value)
        }
    },
    mounted(){
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }
    
}
</script>

<style lang="scss" scoped>

</style>